// extracted by mini-css-extract-plugin
module.exports = {"base":"Col__base__34WPm","centerVertically":"Col__centerVertically__3ts4u","centerHorizontally":"Col__centerHorizontally__flqVv"};